import { getWebInstrumentations, initializeFaro } from "@grafana/faro-web-sdk";
import { TracingInstrumentation } from "@grafana/faro-web-tracing";
import { isProduction, isReview, isRelease, isStaging, isDevelop } from "common/utils/env";

if (process.env.NODE_ENV !== "test") {
  let config = {};
  if (isProduction()) {
    config = {
      url: "https://faro-collector-prod-us-east-0.grafana.net/collect/8b73684cc4d5966217b8ffe62114ec75",
      app: {
        name: "Jiffy prod",
        version: "1.0.0",
        environment: "production"
      },
      sessionTracking: {
        samplingRate: 0.03
      }
    };
  } else if (isReview() || isStaging() || isRelease() || isDevelop()) {
    let environment;
    if (isRelease()) {
      environment = "release";
    } else if (isStaging()) {
      environment = "staging";
    } else if (isDevelop()) {
      environment = "develop";
    } else {
      environment = "review";
    }
    config = {
      url: "https://faro-collector-prod-us-east-0.grafana.net/collect/b0376b4cac1f40ded2609f19a32e59d6",
      app: {
        name: "Jiffy",
        version: "1.0.0",
        environment
      },
      sessionTracking: {
        samplingRate: 1.0
      }
    };
  }

  // Only initialize when we have a valid collector URL and app config
  if (config.url && config.app && config.app.name) {
    initializeFaro({
      ...config,

      instrumentations: [
        // Mandatory, omits default instrumentations otherwise.
        ...getWebInstrumentations(),

        // Tracing package to get end-to-end visibility for HTTP requests.
        new TracingInstrumentation()
      ]
    });
  }
}
